import { createSlice } from '@reduxjs/toolkit'

export const textSlice = createSlice({
  name: 'text',
  initialState: {
    textObjects: [],
  },
  reducers: {
    setTextValue: (state, action) => {
      for (const key in state.textObjects) {
        if (Object.prototype.hasOwnProperty.call(state.textObjects, key)) {
          const element = state.textObjects[key];
          if (element.key === action.payload.key) {
            state.textObjects[key].value = action.payload.value;
          }    
        }
      }
    },
    setTextObjects: (state, action) => {
      state.textObjects = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setTextValue, setTextObjects } = textSlice.actions

export default textSlice.reducer